import { useRef, useState } from "react";

export function useOtpInput(length = 4) {
  const [otp, setOtp] = useState<string[]>(new Array(length).fill(""));
  const inputsRef = useRef<(HTMLInputElement | null)[]>([]);
  const isComplete = otp.every((digit) => digit !== "");

  const getOtpString = () => otp.join("");

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    index: number,
    onChange?: () => void
  ) => {
    onChange?.();
    const value = e.target.value;

    if (/^[0-9]$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      if (index < inputsRef.current.length - 1) {
        inputsRef.current[index + 1]?.focus();
      }
    } else {
      const newOtp = [...otp];
      newOtp[index] = "";
      setOtp(newOtp);
      e.target.value = "";
    }
  };

  const handleKeyDown = (
    e: React.KeyboardEvent<HTMLInputElement>,
    index: number
  ) => {
    if (e.key === "Backspace" && !e.currentTarget.value && index > 0) {
      inputsRef.current[index - 1]?.focus();
    }
  };

  return {
    otp,
    isComplete,
    inputsRef,
    getOtpString,
    handleInputChange,
    handleKeyDown,
  };
}
